module.exports = __webpack_public_path__ + "static/media/fondprix.9f78ccf8.jpg";